'use strict';

const root = document.getElementById('root');
import m from 'mithril';

//load our pages
import game from '../layouts/game.jsx';
import menu from '../layouts/menu.jsx';
import preferences from '../layouts/preferences.jsx';
import menuEtc from '../layouts/menu-etc.jsx';

export function init() {
  m.route(root, '/play', {
    '/play': game,
    '/menu': menu,
    '/menu/preferences': preferences,
    '/menu/etc': menuEtc,
  });
}
